import React from 'react';
import {getImagePath} from "../utils";
import Square from "../elements/Square";

function BoxImage({children, image, className, ...props}) {
    return <div {...props} className={`${className} cursor-pointer`}>
        <Square className="mb-1">
            <img src={getImagePath(image)} className="rounded-lg" alt=""/>
        </Square>
        <div className="text-uppercase text-primary font-weight-medium font-size-0-75 line-height-3">
            {children}
        </div>
    </div>
}

export default BoxImage;